import * as moment from 'moment';
import * as React from 'react';
import { InjectedI18nProps, translate } from '~/utils/translate';

const momentLocaleLoader = (Component) => {
  return translate()(
    // eslint-disable-next-line @typescript-eslint/ban-types
    class extends React.Component<InjectedI18nProps, {}> {
      componentDidMount() {
        // Default moment locale is en so we only load locales when it is not en or en-US
        if (this.props.i18n.language !== 'en' && this.props.i18n.language !== 'en-US') {
          const language = this.props.i18n.language;
          import(`moment/locale/${language}`)
            .then(() => {
              moment.locale(language);
            })
            .catch(() => {});
        }
      }

      render() {
        return <Component {...this.props} />;
      }
    },
  );
};

export default momentLocaleLoader;
